import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export default class GroupApi {
    static star(groupId) {
        return RESTClient.postAuthenticated(`v2/groups/${groupId}/star`, {
            star: 1,
        });
    }

    static unStar(groupId) {
        return RESTClient.postAuthenticated(`v2/groups/${groupId}/star`, {
            star: 0,
        });
    }
}
